import React from "react";
import Select from "react-select";

import { Button } from "aible";

import styles from "./style.module.css";

import AddAccount from "components/Admin/addAccount";
import AddUser from "components/Admin/addUser";
import EditAccountModal from "components/Admin/editAccount";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import FoldersCreateContainer from "containers/Folders/FoldersCreate";

import userIcon from "images/circled-user.svg";

class AccountRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayData: false
    };
  }

  render() {
    const { item, formTime, i } = this.props;
    const { displayData } = this.state;

    return item ? (
      <React.Fragment>
        <tr
          className={styles.rowHover + " " + (i % 2 === 1 ? styles.stripe : "")}
          onClick={() => this.setState({ displayData: !displayData })}
        >
          <td key={item.id}>{item.name}</td>
          <td>{item.type}</td>
          <td>{formTime.toLocaleDateString()}</td>
        </tr>
        {displayData ? (
          <tr id={item.id}>
            <td colSpan="3">
              <ul>
                <li>Created By: {item.created_by.fullname}</li>
                <li>Internal ID : {item.tenant_id}</li>
                <li>Number of Concurrent Jobs: {item.num_concurrent_jobs}</li>
                <li>Status: {item.status}</li>
                <li>Last Updated: {item.updated_date}</li>
              </ul>
            </td>
          </tr>
        ) : (
          ""
        )}
      </React.Fragment>
    ) : (
      <React.Fragment />
    );
  }
}

class UserRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayData: false
    };
  }

  render() {
    const { item, formTime, i, highlightUser, userRole } = this.props;
    const { displayData } = this.state;

    return item ? (
      <React.Fragment>
        <tr
          className={
            styles.rowHover +
            " " +
            (i % 2 === 1 ? styles.stripe : "") +
            " " +
            (highlightUser ? styles.persistHover : "")
          }
          onClick={() => this.setState({ displayData: !displayData })}
        >
          <td className={styles.userCol} key={item.email}>
            {" "}
            {item.email}{" "}
          </td>
          <td className={styles.userCol}>{item.invite ? item.invite.status : ""}</td>
          <td className={styles.userCol}>{formTime.toLocaleDateString()}</td>
          <td className={styles.userCol}>{userRole ? userRole : ""}</td>
        </tr>
        {displayData ? (
          <tr id={item.id}>
            <td colSpan="4">
              <ul>
                <li>Full Name: {item.fullname}</li>
              </ul>
            </td>
          </tr>
        ) : (
          ""
        )}
      </React.Fragment>
    ) : (
      <React.Fragment />
    );
  }
}

class FolderRow extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      item,
      formTime,
      i,
      id,
      handleEditFolderClick,
      setHighlightedFolderRow,
      selectedFolder,
      handleFolderClick,
      filterUsers
    } = this.props;

    return (
      <React.Fragment>
        <tr
          className={
            styles.rowHover +
            " " +
            (i % 2 === 1 ? styles.stripe : "") +
            " " +
            (selectedFolder == id ? styles.persistHover : "")
          }
          onClick={() => handleFolderClick(selectedFolder, id, item)}
          onMouseEnter={() => {
            if (!selectedFolder) {
              setHighlightedFolderRow(id);
              filterUsers(item);
            }
          }}
          onMouseLeave={() => setHighlightedFolderRow(undefined)}
        >
          <td key={item.name}> {item.name} </td>
          <td>{item.created_by.fullname ? item.created_by.fullname : ""}</td>
          <td>{item.default_role_type}</td>
          <td>{formTime.toLocaleDateString()}</td>
        </tr>
        {selectedFolder == id ? (
          <tr
            id={item.id}
            onMouseEnter={() => {
              if (!selectedFolder) {
                setHighlightedFolderRow(id);
                filterUsers(item);
              }
            }}
            onMouseLeave={() => setHighlightedFolderRow(undefined)}
          >
            <td colSpan="3">
              <ul>
                <li>Description: {item.description}</li>
                <li>Number of Blueprints: {item.contents.blueprint_count}</li>
                <li>Number of Projects: {item.contents.project_count}</li>
                <li>Number of Datasets: {item.contents.training_data_count}</li>
                <li>User {item.permissions.can_edit ? "Can " : "Cannot "} Edit Folder</li>
                <li>User {item.permissions.can_delete ? "Can " : "Cannot "} Delete Folder</li>
                <li>User {item.permissions.can_view ? "Can " : "Cannot "} View Folder</li>
                <li>
                  User {item.permissions.can_manage_permissions ? "Can " : "Cannot "} Manage Permissions of Folder
                </li>
                <li>Last Updated: {item.updated_date}</li>
              </ul>
            </td>
            <td>
              <Button onClick={() => handleEditFolderClick(item.id)}>{"Edit Folder"}</Button>
            </td>
          </tr>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}

class Admin extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingUsers: false,
      isLoadingEnvironments: false,
      showAddAccount: false,
      showAddUser: false,
      showAddFolder: false,
      showEditAccount: false,

      showFoldersModal: false,
      selectedFolderId: undefined,
      isEditFolder: true,
      highlightedFolderRow: undefined,
      selectedFolderRow: null,
      folderMembers: [],
      noFolderAddPermit: true
    };

    this.filterUsers = this.filterUsers.bind(this);
    this.handleEditFolderClick = this.handleEditFolderClick.bind(this);
    this.handleFolderClick = this.handleFolderClick.bind(this);
    this.isFolderMember = this.isFolderMember.bind(this);
    this.setFolderMembers = this.setFolderMembers.bind(this);
    this.setHighlightedFolderRow = this.setHighlightedFolderRow.bind(this);
    this.setSelectedFolderRow = this.setSelectedFolderRow.bind(this);
    this.setShowAddAccount = this.setShowAddAccount.bind(this);
    this.setShowAddUser = this.setShowAddUser.bind(this);
    this.setFolderAddPermit = this.setFolderAddPermit.bind(this);
    this.setShowEditAccount = this.setShowEditAccount.bind(this);
  }

  filterUsers(folder) {
    if (!folder) {
      return this.setFolderMembers(null);
    }

    let ids = Object.keys(folder.roles).map((i) => {
      return folder.roles[i].role_user.id;
    });

    this.setFolderMembers(ids);
  }

  getUserRole(roles, id) {
    return roles.find((r) => r?.role_user?.id == id)?.role_type;
  }

  handleCreateFolderClick() {
    this.setState({
      showFoldersModal: true,
      selectedFolderId: undefined,
      isEditFolder: false
    });
  }

  handleFolderClick(id, selectedFolder, item) {
    if (!selectedFolder || selectedFolder == id) {
      this.setSelectedFolderRow(id);
      if (selectedFolder != id) {
        this.filterUsers(item);
      }
    } else {
      this.setSelectedFolderRow(selectedFolder);
      this.filterUsers(item);
    }

    if (selectedFolder && item.permissions.can_manage_permissions) {
      this.setFolderAddPermit(false);
    }
    if (selectedFolder == id) {
      this.setFolderAddPermit(true);
    }
  }

  handleEditFolderClick(id) {
    this.setState({
      showFoldersModal: true,
      selectedFolderId: id,
      isEditFolder: true
    });
  }

  handleHide() {
    this.setState({ showFoldersModal: false });
  }

  isFolderMember(id, highlightedUsers) {
    if (highlightedUsers.indexOf(id) != -1) {
      return true;
    }
    return false;
  }

  setFolderAddPermit(bool) {
    this.setState({ noFolderAddPermit: bool });
  }

  setFolderMembers(ids) {
    this.setState({ folderMembers: ids });
  }

  setHighlightedFolderRow(id) {
    this.setState({ highlightedFolderRow: id });
  }

  setSelectedFolderRow(id) {
    const { selectedFolderRow } = this.state;
    if (id == selectedFolderRow) {
      return this.setState({ selectedFolderRow: null });
    }
    this.setState({ selectedFolderRow: id });
  }

  setShowAddAccount(bool) {
    this.setState({ showAddAccount: bool });
  }

  setShowAddFolder(bool) {
    this.setState({ showAddFolder: bool });
  }

  setShowAddUser(bool) {
    this.setState({ showAddUser: bool });
  }

  setShowEditAccount(bool) {
    this.setState({ showEditAccount: bool });
  }

  /*---LifeCycle methods---*/

  componentDidMount() {
    const { organizationID } = this.props;
    this.updateOrgAndList(organizationID && organizationID.id, true);
  }

  /*---tenant Methods---*/

  genOptions(data) {
    const names = data.map((idx) => idx.fullname);
    const values = data.map((idx) => idx.id);
    var options = [];
    for (var idx = 0; idx < values.length; idx++) {
      options.push({ value: values[idx], label: names[idx] });
    }
    return options;
  }

  getTenantData(val) {
    const { data } = this.props;
    for (let item in data) {
      if (data[item].id == val) {
        return data[item];
      }
    }
    return null;
  }

  updateOrgAndList(val, skipFetch = false) {
    const { updateSelectedOrganization, updateUsers, selectTenant, updateSelectedTenantSharing, selectedOrganization } =
      this.props;
    const tenant = this.getTenantData(val);
    if (!tenant) {
      return;
    }

    if (!skipFetch) {
      selectTenant(tenant);
    }
    updateSelectedOrganization(val);
    updateUsers(tenant);
    const share = tenant.share_behavior == "PUBLIC" ? true : false;
    updateSelectedTenantSharing(selectedOrganization, share);
    return;
  }

  /*---- Render Methods ----*/

  renderAccountInfo(accounts) {
    const retData = accounts
      ? accounts.map(function (item, i) {
          let formTime = new Date(Date.parse(item.created_date));
          return <AccountRow item={item} formTime={formTime} i={i} />;
        })
      : "";

    return retData;
  }

  renderFoldersInfo(folders) {
    const { selectedFolderRow } = this.state;

    const items = folders ? (
      Object.keys(folders).map((item, i) => {
        let formTime = new Date(Date.parse(folders[item].created_date));
        return (
          <FolderRow
            item={folders[item]}
            formTime={formTime}
            i={i}
            id={item}
            handleEditFolderClick={this.handleEditFolderClick}
            setHighlightedFolderRow={this.setHighlightedFolderRow}
            setFolderMembers={this.setFolderMembers}
            selectedFolder={selectedFolderRow}
            handleFolderClick={this.handleFolderClick}
            filterUsers={this.filterUsers}
            setFolderAddPermit={this.setFolderAddPermit}
          />
        );
      })
    ) : (
      <tr id="noData">
        <td colSpan="4">No folder Data</td>
      </tr>
    );
    return items;
  }

  renderUsersInfo(users, highlightedUsers, selectedFolderUsers, selectedFolder) {
    const isFolderMember = this.isFolderMember;
    const getUserRole = this.getUserRole;
    let selectedI = -1;
    const items = users
      ? users.map(function (item, i) {
          let formTime = new Date(Date.parse(item.invite?.created_date ?? item.created_date));
          let highlightUser = highlightedUsers ? isFolderMember(item.id, highlightedUsers) : false;
          let selectedUser = selectedFolderUsers ? isFolderMember(item.id, selectedFolderUsers) : false;
          if (selectedFolderUsers) {
            if (selectedUser) {
              const userRole = getUserRole(selectedFolder && selectedFolder.roles ? selectedFolder.roles : [], item.id);
              selectedI++;
              return <UserRow item={item} formTime={formTime} i={selectedI} userRole={userRole} />;
            }
          } else {
            return <UserRow item={item} formTime={formTime} i={i} highlightUser={highlightUser} />;
          }
        })
      : "Select A group to Admin";
    return items;
  }

  render() {
    const { data, users, accounts, isLoadingAccounts, isLoadingUsers, folders, updateAccountConfig } = this.props;

    const {
      showAddAccount,
      showAddUser,
      showAddFolder,
      showFoldersModal,
      selectedFolderId,
      isEditFolder,
      highlightedFolderRow,
      selectedFolderRow,
      folderMembers,
      noFolderAddPermit,
      showEditAccount
    } = this.state;

    const highlightedUsers = highlightedFolderRow && !selectedFolderRow ? folderMembers : null;
    const selectedFolderUsers = selectedFolderRow ? folderMembers : null;

    const selectedFolder = folders[selectedFolderRow];

    const azureAccounts = accounts.filter((a) => a.type == "AZURE");

    return (
      <div className={styles.admin}>
        <div className={styles.selectTenant}>
          <div className={styles.selectContainer}>
            Select a Workspace:
            <Select
              options={this.genOptions(data)}
              defaultValue={{ label: this.props.activeTenant.fullname, value: this.props.activeTenant.id }}
              onChange={(val) => this.updateOrgAndList(val.value)}
            />
          </div>
        </div>
        <div className={styles.personnel + " " + styles.Flex}>
          {/* <div className={styles.awsAccount + " " }>
                    <div className={styles.classRow + " " +styles.vertCenterText}>
                    <div className={styles.vertCenterText}>Accounts</div>
                        <div className={styles.btnFloat}>
                            <Button type="secondary" className={styles.buttonPad + " " + styles.buttonStyle}
                                    disabled={showEditAccount || azureAccounts.length == 0}
                                    onClick={() => this.setState({showEditAccount: !showEditAccount})}>Edit Accounts
                            </Button>
                        </div>
                        <div className={styles.btnFloat}>
                            <Button type="secondary" className={styles.buttonPad + " " + styles.buttonStyle}
                                    disabled={showAddAccount}
                                    onClick={() => this.setState({showAddAccount: !showAddAccount})}>+ New Account
                            </Button>
                        </div>
                    </div>
                    < AddAccount setShowAddAccount={this.setShowAddAccount}
                        {...this.props} hidden={!showAddAccount} />
                    <table width="500" border="1"
                            summary="purpose/structure for speech output">
                        <colgroup id="colgroup" align="center"
                            valign="middle" title="title" width="1*"
                            span="2" />
                        <thead>
                            <tr>
                                <th scope="col">Account</th>
                                <th scope="col">Type</th>
                                <th scope="col">Created On</th>
                            </tr>
                        </thead>
                        {isLoadingAccounts ? "" :
                            <tbody className={styles.environmentData}>{this.renderAccountInfo(accounts)}</tbody>
                        }
                    </table>
                    { isLoadingAccounts ? (
                        <div className={styles.lHolder}>
                            <LoadingIndicator style={{ marginTop: "-60px" }} />
                        </div>
                    ) : "" }
                </div> */}
          <div className={styles.awsAccount + " "}>
            <div className={styles.classRow + " " + styles.vertCenterText}>
              <div className={styles.vertCenterText}>Folders</div>
              <div className={styles.btnFloat}>
                <Button
                  type="secondary"
                  className={styles.buttonPad + " " + styles.buttonStyle}
                  disabled={showAddFolder}
                  onClick={() => this.handleCreateFolderClick()}
                >
                  + New Folder
                </Button>
              </div>
            </div>
            <table width="600" border="1" summary="purpose/structure for speech output">
              <colgroup id="colgroup" align="center" valign="middle" title="title" width="1*" span="2" />
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Owner</th>
                  <th scope="col">Default Role</th>
                  <th scope="col">Created On</th>
                </tr>
              </thead>
              {isLoadingAccounts ? (
                ""
              ) : (
                <tbody className={styles.environmentData}>{this.renderFoldersInfo(folders)}</tbody>
              )}
            </table>
            {!folders ? (
              <div className={styles.lHolder}>
                <LoadingIndicator style={{ marginTop: "-120px" }} />
              </div>
            ) : (
              ""
            )}
          </div>
          <div className={styles.workspaceUsers}>
            <div className={styles.classRow}>
              <img src={userIcon} />
              <div className={styles.vertCenterText}>Users</div>
              <div className={styles.btnFloat}>
                <Button
                  type="secondary"
                  disabled={showAddUser || noFolderAddPermit}
                  onClick={() => this.setState({ showAddUser: !showAddUser })}
                >
                  + Invite User{" "}
                </Button>
                <div className={styles.spacer} />
              </div>
            </div>
            <AddUser setShowAddUser={this.setShowAddUser} {...this.props} hidden={!showAddUser} />
            <div className={styles.center}>
              <table className={styles.userTable} width="700" border="1">
                <colgroup>
                  <col span="1" style={{ width: "50%" }} />
                  <col span="1" style={{ width: "20%" }} />
                  <col span="1" style={{ width: "20%" }} />
                  <col span="1" style={{ width: "10%" }} />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Invitation Status</th>
                    <th scope="col">Created On</th>
                    <th scope="col">Role</th>
                  </tr>
                </thead>
                {isLoadingUsers ? (
                  ""
                ) : (
                  <tbody className={styles.userData}>
                    {this.renderUsersInfo(users, highlightedUsers, selectedFolderUsers, selectedFolder)}
                  </tbody>
                )}
              </table>
              {isLoadingUsers ? (
                <div className={styles.lHolder}>
                  <LoadingIndicator style={{ marginTop: "-60px" }} />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <FoldersCreateContainer
          showModal={showFoldersModal}
          isEdit={isEditFolder}
          id={selectedFolderId}
          handleHide={() => this.handleHide()}
        />
        <EditAccountModal
          showModal={showEditAccount}
          setShowEditAccount={this.setShowEditAccount}
          updateAccountConfig={updateAccountConfig}
          accounts={azureAccounts}
        />
      </div>
    );
  }
}

export default Admin;
